"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsPropertyCard = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var SearchHighlight_1 = require("../../shared/components/SearchHighlight");
var MetricsUseCaseCallout_1 = require("./MetricsUseCaseCallout");
/**
 * Single signal card in the right panel. Owns the local pill ref used
 * to anchor the use-case callout but delegates open/close state to the
 * parent so only one callout is open at a time across the panel.
 *
 * The card also exposes a per-row expand chevron when the canonical
 * element has merged surface variants (`aliases`). Expanding reveals
 * an inline accordion listing every alias the extraction matcher
 * folded into this canonical row — useful when reviewing whether the
 * cascade (EXACT / FUZZY / EMBEDDING) merged things sensibly.
 */
exports.MetricsPropertyCard = function (_a) {
    var _b;
    var property = _a.property, isSelected = _a.isSelected, isChanged = _a.isChanged, searchMatcher = _a.searchMatcher, openUseCasesPropertyId = _a.openUseCasesPropertyId, onToggleSelection = _a.onToggleSelection, onToggleUseCases = _a.onToggleUseCases, onDismissUseCases = _a.onDismissUseCases, onOpenUseCase = _a.onOpenUseCase;
    var pillRef = react_1.useRef(null);
    var _c = react_1.useState(false), isExpanded = _c[0], setIsExpanded = _c[1];
    var useCaseCount = property.useCases.length;
    var isCalloutOpen = openUseCasesPropertyId === property.id;
    // Normalize defensively: a stale draft (or an older backend
    // response) may still have aliases as plain strings instead of
    // `{ text, useCases }`, and per-alias `useCases` as bare id
    // strings instead of `{ id, title }`. Handle every shape so this
    // card never crashes mid-render after a hot-reload or cache miss.
    var aliases = ((_b = property.aliases) !== null && _b !== void 0 ? _b : []).map(function (alias) {
        var _a;
        if (typeof alias === 'string') {
            return { text: alias, useCases: [] };
        }
        var rawList = Array.isArray(alias.useCases) ? alias.useCases : [];
        var useCases = rawList
            .map(function (raw) {
            if (typeof raw === 'string') {
                return { id: raw, title: raw };
            }
            if (raw && typeof raw === 'object') {
                var obj = raw;
                var id = typeof obj.id === 'string' ? obj.id : '';
                if (!id) {
                    return null;
                }
                var title = typeof obj.title === 'string' && obj.title.length > 0 ? obj.title : id;
                return { id: id, title: title };
            }
            return null;
        })
            .filter(function (ref) { return ref !== null; });
        return {
            text: (_a = alias.text) !== null && _a !== void 0 ? _a : '',
            useCases: useCases,
        };
    });
    var aliasCount = aliases.length;
    var canExpand = aliasCount > 0;
    var className = 'ws-metrics-property-card' +
        (isSelected ? ' is-selected' : '') +
        (isChanged ? ' is-changed' : '') +
        (isExpanded ? ' is-expanded' : '');
    return (react_1.default.createElement("div", { key: property.id, className: className, role: "button", tabIndex: 0, "aria-pressed": isSelected, "aria-expanded": canExpand ? isExpanded : undefined, onClick: function (event) {
            // Ignore clicks coming from the use-case pill / callout / the
            // expand chevron / the alias list so they can do their own
            // thing without also toggling selection.
            var target = event.target;
            if (target.closest('.ws-metrics-property-aside') ||
                target.closest('.ws-metrics-property-aliases')) {
                return;
            }
            onToggleSelection(property.id);
        }, onKeyDown: function (event) {
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                onToggleSelection(property.id);
            }
        } },
        react_1.default.createElement("div", { className: "ws-metrics-property-row" },
            react_1.default.createElement(office_ui_fabric_react_1.Checkbox, { checked: isSelected, onChange: function () { return onToggleSelection(property.id); }, ariaLabel: "Select " + property.name }),
            react_1.default.createElement("div", { className: "ws-metrics-property-main" },
                react_1.default.createElement("span", { className: "ws-metrics-property-name" },
                    react_1.default.createElement(SearchHighlight_1.HighlightedText, { value: property.name, matcher: searchMatcher }))),
            react_1.default.createElement("div", { className: "ws-metrics-property-aside" },
                react_1.default.createElement("button", { type: "button", className: "ws-metrics-usecase-pill", ref: pillRef, disabled: useCaseCount === 0, title: useCaseCount === 0
                        ? 'Not referenced in any use case'
                        : "Used in " + useCaseCount + " use case" + (useCaseCount === 1 ? '' : 's'), onClick: function () {
                        if (useCaseCount === 0) {
                            return;
                        }
                        onToggleUseCases(property.id);
                    } },
                    react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "ReminderGroup" }),
                    react_1.default.createElement("span", null,
                        "Used in ",
                        useCaseCount,
                        " use case",
                        useCaseCount === 1 ? '' : 's')),
                canExpand && (react_1.default.createElement("button", { type: "button", className: 'ws-metrics-property-expand' + (isExpanded ? ' is-open' : ''), "aria-label": isExpanded
                        ? "Hide merged variants for " + property.name
                        : "Show " + aliasCount + " merged variant" + (aliasCount === 1 ? '' : 's') + " for " + property.name, title: isExpanded
                        ? 'Hide merged variants'
                        : "Show " + aliasCount + " merged variant" + (aliasCount === 1 ? '' : 's'), "aria-expanded": isExpanded, onClick: function (event) {
                        event.stopPropagation();
                        setIsExpanded(function (current) { return !current; });
                    } },
                    react_1.default.createElement("span", { className: "ws-metrics-property-expand-count" }, aliasCount),
                    react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: isExpanded ? 'ChevronUp' : 'ChevronDown' }))))),
        canExpand && isExpanded && (react_1.default.createElement("div", { className: "ws-metrics-property-aliases", role: "region", "aria-label": "Merged variants for " + property.name },
            react_1.default.createElement("div", { className: "ws-metrics-property-aliases-header" },
                "Merged variants (",
                aliasCount,
                ")"),
            react_1.default.createElement("ul", { className: "ws-metrics-property-aliases-list" }, aliases.map(function (alias) { return (react_1.default.createElement("li", { key: alias.text, className: "ws-metrics-property-alias-item" },
                react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "BranchMerge" }),
                react_1.default.createElement("span", { className: "ws-metrics-property-alias-text" },
                    react_1.default.createElement(SearchHighlight_1.HighlightedText, { value: alias.text, matcher: searchMatcher })),
                alias.useCases.length > 0 && (react_1.default.createElement("span", { className: "ws-metrics-property-alias-usecases", "aria-label": "Seen in " + alias.useCases.length + " use case" + (alias.useCases.length === 1 ? '' : 's') }, alias.useCases.map(function (useCase) {
                    // Render the numeric id prominently — that's
                    // what the rest of the system tracks use cases
                    // by — and append the title for human context.
                    // The title alone (e.g. a repo slug) often
                    // doesn't match anything the user recognises
                    // in the navigation surface.
                    var hasFriendlyTitle = useCase.title.length > 0 && useCase.title !== useCase.id;
                    var label = hasFriendlyTitle
                        ? "#" + useCase.id + " \u00B7 " + useCase.title
                        : "#" + useCase.id;
                    return (react_1.default.createElement("button", { key: useCase.id, type: "button", className: "ws-metrics-property-alias-usecase-chip", title: "Open use case #" + useCase.id + (hasFriendlyTitle ? " (" + useCase.title + ")" : ''), onClick: function (event) {
                            event.stopPropagation();
                            onOpenUseCase(useCase.id);
                        } },
                        react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "OpenInNewWindow" }),
                        react_1.default.createElement("span", null, label)));
                }))))); })))),
        isCalloutOpen && (react_1.default.createElement(MetricsUseCaseCallout_1.MetricsUseCaseCallout, { property: property, target: pillRef.current, onDismiss: onDismissUseCases, onOpenUseCase: onOpenUseCase }))));
};
